<script>
  import { catalog } from '../base/store'
  import Ordering from './Ordering.svelte'
  import CatalogList from './CatalogList.svelte'
  import Pagination from './Pagination.svelte'
  $: ({ count: N="...", count_suffix: suffix="ий" } = ($catalog.data || {}).pagination || {})
</script>

<div class="catalog-carts__inner">
  <div class="sort-wrapper">
    <div class="sort">
      <Ordering/>
    </div>
    <div class="count-carts">
      <p>
        Найдено {N} предложен{suffix}
      </p>
    </div>
  </div>
  <ul class="catalog-carts__items" id="node-catalog-list">
    <CatalogList/>
  </ul>
  <div class="pagination__buttons-catalog-wrapper">
    <Pagination/>
  </div>
</div>